import { render, staticRenderFns } from "./tvenderbasicinfo-add-or-update.vue?vue&type=template&id=2e4f426a"
import script from "./tvenderbasicinfo-add-or-update.vue?vue&type=script&lang=js"
export * from "./tvenderbasicinfo-add-or-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports